import api from './utilBackoffice';

const controller = 'RedeLoja';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  ListarComissionamento: newDto => {
    return api.Axios.GetParams(url + '/ListarComissionamento', newDto);
  },
  CopiaParametrosLoja: dto => {
    return api.Axios.Post(url, dto);
  },
  GetAllRedeloja: dto => {
    return api.Axios.GetParams(url + '/GetAll', dto);
  }
});
